import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
    PHONE_INPUT_MAX_LENGTH,
    hasPhoneInputValue,
    isSanitizedPhoneValid,
    sanitizePhoneInput,
} from 'utils/helpers/functions/sanitizePhoneInput';

interface ClientPhoneFieldProps {
    value: string;
    onChange: (value: string) => void;
    label: string;
    disabled?: boolean;
}

const ClientPhoneField = ({ value, onChange, label, disabled = false }: ClientPhoneFieldProps) => {
    const { t } = useTranslation(['Clients']);
    const isValidPhone = isSanitizedPhoneValid(value);

    return (
        <Form.Group className="mb-3">
            <div className="d-flex justify-content-between">
                <Form.Label>{label}</Form.Label>
                {hasPhoneInputValue(value) && (
                    <div className="pe-1 position-relative d-flex align-items-start">
                        <span
                            className={`badge bg-light-${isValidPhone ? 'success' : 'danger'}`}
                            style={{ height: 'fit-content', paddingBottom: '2px' }}
                        >
                            {isValidPhone ? t('phoneValid') : t('phoneNotValid')}
                        </span>
                    </div>
                )}
            </div>
            <Form.Control
                disabled={disabled}
                value={value}
                maxLength={PHONE_INPUT_MAX_LENGTH}
                onChange={(e) => onChange(sanitizePhoneInput(e.target.value))}
            />
        </Form.Group>
    );
};

export default ClientPhoneField;
